import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["entity", "filters", "zIndex"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useToggle } from '@infl-ts/util-hooks';
import TuneIcon from '@mui/icons-material/Tune';
import { Box, Button, Checkbox, FormControlLabel, paperClasses, SwipeableDrawer, Switch, Typography, useMediaQuery } from '@mui/material';
import * as A from 'fp-ts/Array';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as Ord from 'fp-ts/Ord';
import * as Str from 'fp-ts/string';
import { useEffect, useRef } from 'react';
import { Translation, useTranslation } from 'react-i18next';
import { Popover } from '../popover';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var updateCheckedFilters = function updateCheckedFilters(clickedFilter, filters) {
  return pipe(filters, A.findIndex(function (cat) {
    return cat === clickedFilter;
  }), O.match(function () {
    return pipe(filters, A.append(clickedFilter));
  }, function (index) {
    return A.unsafeDeleteAt(index, filters);
  }));
};

var FilterCheckbox = function FilterCheckbox(_ref) {
  var checked = _ref.checked,
      onChange = _ref.onChange,
      label = _ref.label;
  return /*#__PURE__*/_jsx(FormControlLabel, {
    sx: {
      ml: 0.5
    },
    control: /*#__PURE__*/_jsx(Checkbox, {
      checked: checked,
      onChange: onChange
    }),
    label: label,
    "data-element": "FormControlLabel",
    "data-component": "FilterCheckbox",
    "data-source-file": "index.tsx"
  });
};

var FilterToggle = function FilterToggle(_ref2) {
  var checked = _ref2.checked,
      _onChange = _ref2.onChange,
      header = _ref2.header,
      label = _ref2.label,
      hasCategories = _ref2.hasCategories,
      t = _ref2.t;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Typography, {
      sx: {
        mt: hasCategories ? 1.5 : 0
      },
      variant: "h5",
      "data-element": "Typography",
      "data-component": "FilterToggle",
      "data-source-file": "index.tsx",
      children: t(header)
    }), /*#__PURE__*/_jsx(FormControlLabel, {
      control: /*#__PURE__*/_jsx(Switch, {
        checked: checked,
        onChange: function onChange(evt) {
          return _onChange(evt.target.checked);
        }
      }),
      label: label,
      "data-element": "FormControlLabel",
      "data-source-file": "index.tsx"
    })]
  });
};

var byName = pipe(Str.Ord, Ord.contramap(function (category) {
  return category.name.toLowerCase();
}));

var Filters = function Filters(_ref3) {
  var _ref3$filters = _ref3.filters,
      checkboxes = _ref3$filters.checkboxes,
      filterToggle = _ref3$filters.toggle,
      handleCheckboxChange = _ref3.handleCheckboxChange,
      handleToggleChange = _ref3.handleToggleChange,
      checkboxOptions = _ref3.checkboxOptions,
      _ref3$checkboxHeader = _ref3.checkboxHeader,
      checkboxHeader = _ref3$checkboxHeader === void 0 ? 'Categories' : _ref3$checkboxHeader,
      toggle = _ref3.toggle,
      isMobile = _ref3.isMobile;
  var hasCategories = A.isNonEmpty(checkboxOptions);
  var ref = useRef(null);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  useEffect(function () {
    !isMobile && (ref === null || ref === void 0 ? void 0 : ref.current) && (ref === null || ref === void 0 ? void 0 : ref.current.scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    }));
  }, [filterToggle, isMobile, ref]);
  return /*#__PURE__*/_jsxs(Box, {
    ref: ref,
    sx: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 200,
      scrollMarginTop: '100px'
    },
    "data-element": "Box",
    "data-component": "Filters",
    "data-source-file": "index.tsx",
    children: [hasCategories && /*#__PURE__*/_jsx(Typography, {
      variant: "h5",
      sx: {
        maxWidth: '60%'
      },
      children: t(checkboxHeader)
    }), !isMobile && /*#__PURE__*/_jsx(Button, {
      sx: {
        mx: 0.5,
        p: 0,
        position: 'fixed',
        right: 0,
        mr: 3
      },
      variant: "text",
      onClick: function onClick() {
        handleCheckboxChange([]);
        if (filterToggle && handleToggleChange) handleToggleChange(false);
      },
      children: t('Reset')
    }), hasCategories && A.sort(byName)(checkboxOptions).map(function (option) {
      return /*#__PURE__*/_jsx(FilterCheckbox, {
        checked: checkboxes.includes(option.id),
        onChange: function onChange() {
          return handleCheckboxChange(updateCheckedFilters(option.id, checkboxes));
        },
        label: option.name
      }, option.id);
    }), filterToggle !== undefined && handleToggleChange && toggle && /*#__PURE__*/_jsx(FilterToggle, _objectSpread({
      hasCategories: hasCategories,
      checked: filterToggle,
      onChange: handleToggleChange,
      t: t
    }, toggle))]
  });
};

var FilteringButton = function FilteringButton(_ref4) {
  var onClick = _ref4.onClick,
      filters = _ref4.filters;
  return /*#__PURE__*/_jsxs(Button, {
    sx: {
      ml: 1,
      minWidth: 108,
      height: 40
    },
    color: "secondary",
    variant: "contained",
    disableElevation: true,
    onClick: onClick,
    "data-element": "Button",
    "data-component": "FilteringButton",
    "data-source-file": "index.tsx",
    children: [/*#__PURE__*/_jsx(TuneIcon, {
      sx: {
        mr: 1,
        height: function height(t) {
          return t.spacing(2.5);
        },
        width: function width(t) {
          return t.spacing(2.5);
        }
      },
      "data-element": "TuneIcon",
      "data-component": "FilteringButton",
      "data-source-file": "index.tsx"
    }), /*#__PURE__*/_jsx(Translation, {
      "data-element": "Translation",
      "data-source-file": "index.tsx",
      children: function children(t) {
        return /*#__PURE__*/_jsx(Typography, {
          variant: "body2",
          sx: {
            fontWeight: 'bold',
            whiteSpace: 'nowrap'
          },
          children: pipe(filters.checkboxes.length + (filters.toggle ? 1 : 0), function (totalFilters) {
            return t('Filters') + (totalFilters > 0 ? " (".concat(totalFilters, ")") : '');
          })
        });
      }
    })]
  });
};

export var FilterButton = function FilterButton(_ref5) {
  var entity = _ref5.entity,
      filters = _ref5.filters,
      zIndex = _ref5.zIndex,
      rest = _objectWithoutProperties(_ref5, _excluded);

  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isOpen = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      open = _useToggle2$.on,
      close = _useToggle2$.off;

  var uniqueFilters = {
    checkboxes: A.uniq(Str.Eq)(filters.checkboxes),
    toggle: filters.toggle
  };
  var filterToggle = filters.toggle;
  var handleCheckboxChange = rest.handleCheckboxChange,
      handleToggleChange = rest.handleToggleChange;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  return isMobile ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FilteringButton, {
      onClick: isOpen ? close : open,
      filters: uniqueFilters
    }), /*#__PURE__*/_jsxs(SwipeableDrawer, {
      sx: _defineProperty({}, "& .".concat(paperClasses.root), {
        p: 2
      }),
      open: isOpen,
      onClose: close,
      onOpen: open,
      anchor: "bottom",
      disablePortal: true,
      disableSwipeToOpen: true,
      children: [/*#__PURE__*/_jsx(Typography, {
        sx: {
          fontWeight: 'bold',
          pb: 2
        },
        variant: "h4",
        children: t("Filter {{entity}}", {
          entity: t(entity)
        })
      }), /*#__PURE__*/_jsx(Filters, _objectSpread({
        t: t,
        filters: uniqueFilters,
        isMobile: isMobile
      }, rest)), /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          justifyContent: 'flex-end'
        },
        children: [/*#__PURE__*/_jsx(Button, {
          sx: {
            mx: 1
          },
          size: "large",
          variant: "text",
          onClick: function onClick() {
            handleCheckboxChange([]);
            if (filterToggle && handleToggleChange) handleToggleChange(false);
          },
          children: t('Reset')
        }), /*#__PURE__*/_jsx(Button, {
          sx: {
            mx: 1
          },
          size: "large",
          variant: "contained",
          onClick: close,
          children: t('Close')
        })]
      })]
    })]
  }) : /*#__PURE__*/_jsx(Popover, {
    content: function content() {
      return /*#__PURE__*/_jsx(Filters, _objectSpread({
        t: t,
        filters: uniqueFilters
      }, rest));
    },
    preventFallback: true,
    zIndex: zIndex,
    placement: "bottom-end",
    children: /*#__PURE__*/_jsx(FilteringButton, {
      filters: uniqueFilters
    })
  });
};